// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3kUdm","label":"SetPasswdForm_label__3DbvU"};